// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topActions {
  display: flex;
  width: 97%;
  padding: 10px 0px;
  justify-content: space-between;
  align-items: center;
}
.topActions .cancel {
  all: unset;
  font-family: "Roboto", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 155%;
  color: #699BB6;
}
.topActions .title {
  font-family: "Roboto", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 155%;
  color: #FFFFFF;
  text-align: center;
}
.topActions .save {
  min-width: 45px;
  font-family: "Roboto", sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 155%;
  color: #699BB6;
}`, "",{"version":3,"sources":["webpack://./src/common/topActions/index.scss","webpack://./src/scss/fonts.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,UAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAEI;EACI,UAAA;EACA,iCCNC;EDOD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cEfS;AFejB;AAEI;EACI,iCCdC;EDeD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cExBK;EF0BL,kBAAA;AADR;AAGI;EACI,eAAA;EACA,iCCzBC;ED0BD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cElCS;AFiCjB","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/fonts.scss';\n\n.topActions{\n    display: flex;\n    width: 97%;\n    padding: 10px 0px;\n    justify-content: space-between;\n    align-items: center;\n    .cancel{\n        all:unset;\n        font-family: $Roboto;\n        font-size: 17px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 155%; \n        color: $color-Secondary;\n    }\n    .title{\n        font-family: $Roboto;\n        font-size: 17px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 155%;\n        color:$color-White;\n        // margin-left: 42px;\n        text-align: center;\n    }\n    .save{\n        min-width: 45px;\n        font-family: $Roboto;\n        font-size: 17px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 155%; \n        color: $color-Secondary;\n    }\n}","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
